import angular from 'angular';

let inject = ['$scope', '$uibModalInstance', 'product', '$window'];

class ModalQuantityCartController {
    constructor($scope, $uibModalInstance, product, $window) {
        this.$scope = $scope;
        this.product = angular.copy(product);
        this.$window = $window;
        this.$uibModalInstance = $uibModalInstance;
        this.itemQuantityToAdd = 1;
        this.user = {};
    }

    ProductQuantity() {
      this.itemQuantityToAdd = parseInt(this.itemQuantityToAdd)
    }

    increaseItemQuantityToAdd() {
        if (!this.itemQuantityToAdd)
            this.itemQuantityToAdd = 1;
        else
            this.itemQuantityToAdd++;
    };

    decreaseItemQuantityToAdd() {
        if (!this.itemQuantityToAdd)
            this.itemQuantityToAdd = 1;
        else if (this.itemQuantityToAdd > 1) {
            this.itemQuantityToAdd--;
        }
    };

    addItemToCart(product, quantity) {
        this.$uibModalInstance.close({product: product, quantity: quantity});
        console.log(product);
        console.log(quantity);
        this.$window.dataLayer.push({
          'event': 'add_to_cart',
          'ecommerce': {
              'items': [{                        //  adding a product to a shopping cart.
                'item_name': product.name,
                'item_id': product.id,
                'price':  product.currentPrice,
                'item_category': product.category.slug,
                'quantity': quantity
              }]
          }
        });
    }

    cancel() {
        this.$uibModalInstance.dismiss('cancel');
    }
}

ModalQuantityCartController.$inject = inject;

export default ModalQuantityCartController;



// WEBPACK FOOTER //
// ./www/components/catalog/modal-quantity-cart/modal-quantity-cart.controller.js